// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-header[data-v-714854a0]{background-color:#fff}@media screen and (min-width:768px){.card[data-v-714854a0]{border-radius:8px;-webkit-box-shadow:1px 2px 3px #d6d1d1;box-shadow:1px 2px 3px #d6d1d1}.card-header[data-v-714854a0]{border-top-left-radius:8px!important;border-top-right-radius:8px!important}}", ""]);
// Exports
module.exports = exports;
